<template>
<div>
    <h3>{{resource.subtitle}}</h3>
    <div v-html='resource.content'></div>
<iframe :src="embedURL" style="width:100%;height:600px" frameborder=0 allowfullscreen></iframe>
</div>
</template>

<script>
export default {
    name: 'embed-viewer',
    props: ['resource'],
    computed: {
        embedURL() {
            return this.resource.url;
        }
    }
}
</script>

